import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { error } from 'console';
import { Observable, of } from 'rxjs';



@Component({
  selector: 'app-customer-request',
  templateUrl: './customer-request.component.html',
  styleUrls: ['./customer-request.component.css']
})
export class CustomerRequestComponent implements OnInit {
  @Input() productType: string = '';
  userName = '';
  email = '';
  phoneNumber = '';
  description = '';
  isInValidRequest = true;

  constructor(private fb: FormBuilder, private http: HttpClient) {
  }

  ngOnInit(): void {
    if (this.productType === '') {
      this.productType = 'semi';
    }
  }

  request() {
    alert('test');
    this.sendMail().subscribe((result: any) => {
      alert(result);
    })
  }

  valueChanged() {
    if (this.userName.trim().length === 0) {
      this.isInValidRequest = true;
    } else if (this.email.trim().length === 0) {
      this.isInValidRequest = true;
    } else {
      this.isInValidRequest = false;
    }
  }

  sendMail(): Observable<any> {
    const url = 'http://localhost:4200/sendmail';
    const httpOption = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
    }
    return this.http.post<any>(url, '', httpOption).pipe((this.handleError<any>('', undefined)));
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return of(result as T);
    }
  }
}
